function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

import styled from 'react-emotion';
import React, { createElement } from 'react';
import PropTypes from 'prop-types';
import { MEDIA_QUERIES, NTA_LIGHT, LEVEL_SIZE, FONT_SIZES, LEVEL_TAG } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
var StyledHeader = styled(function (_ref) {
  var level = _ref.level,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["level", "children"]);

  return createElement(LEVEL_TAG[level], props, children);
})({
  fontFamily: NTA_LIGHT,
  fontWeight: 'bold',
  margin: 0
}, function (_ref2) {
  var _ref3;

  var level = _ref2.level,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? LEVEL_SIZE[level] : _ref2$size;
  return _ref3 = {
    fontSize: FONT_SIZES[size].mobile.fontSize,
    lineHeight: FONT_SIZES[size].mobile.lineHeight,
    marginBottom: FONT_SIZES[size].mobile.spacing
  }, _ref3[MEDIA_QUERIES.LARGESCREEN] = {
    fontSize: FONT_SIZES[size].tablet.fontSize,
    lineHeight: FONT_SIZES[size].tablet.lineHeight,
    marginBottom: FONT_SIZES[size].tablet.spacing
  }, _ref3[MEDIA_QUERIES.PRINT] = {
    fontSize: FONT_SIZES[size].print.fontSize
  }, _ref3;
});
/**
 *
 * ### Usage
 *
 *
 * Simple
 * ```jsx
 * <Header level={1}>Heading text</Header>
 * ```
 *
 * Using shortcuts
 * ```jsx
 * import { H1, H2, H3, H4, H5, H6 } from "@govuk-react/header";
 *
 * <H1>h1</H1>
 * <H2>h2</H2>
 * <H3>h3</H3>
 * <H4>h4</H4>
 * <H5>h5</H5>
 * <H6>h6</H6>
 * ```
 *
 * Differing sizes
 * ```jsx
 * <Header level={6} size="XXLARGE">
 *   h6 with XXLARGE style
 * </Header>
 * <Header level={2} size="XSMALL">
 *   h2 with XSMALL style
 * </Header>
 * <H3 size="LARGE">h3 with LARGE style</H3>
 * ```
 *
 * Props pass through
 * ```jsx
 * <Header onClick={() => { console.log('clicked'); }}>Click me</Header>
 * ```
 *
 * ### References:
 * - https://govuk-elements.herokuapp.com/typography/#typography-headings
 * - https://github.com/alphagov/govuk_frontend_toolkit/blob/master/stylesheets/_typography.scss
 * - https://github.com/alphagov/govuk-frontend/blob/master/src/globals/scss/core/_typography.scss
 * - https://github.com/alphagov/govuk_elements/blob/master/packages/govuk-elements-sass/public/sass/elements/_elements-typography.scss
 */

var Header = function Header(props) {
  return React.createElement(StyledHeader, props);
};

Header.defaultProps = {
  level: 1,
  size: undefined
};
export default withWhiteSpace()(Header);
export { H1, H2, H3, H4, H5, H6 } from './presets';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/header/es/index.js
// module id = 25
// module chunks = 0